import React from 'react';
import cc from 'classcat';
import './index.less';

type Props = {
  size?: 'default' | 'large';
  className?: string;
  emptyOddStyle?: boolean;
  colorVariables?: Record<string, string>;
};

export const EmptyOdd = React.memo(
  ({ size, className = '', emptyOddStyle, colorVariables }: Props) => {
    return (
      <span
        className={cc([
          className,
          'xOddButton',
          'xOddButton--disabled',
          {
            'xOddButton--large': size === 'large',
            empty__OddStyle: emptyOddStyle
          }
        ])}
        onClick={e => e.stopPropagation()}
        style={
          colorVariables && {
            background: colorVariables.oddsBgColor,
            border: `1px solid ${colorVariables.oddBorderColor}`
          }
        }
      >
        <div
          className="emptyRadioBtnContainer"
          style={
            colorVariables && {
              color: colorVariables.oddTextColor
            }
          }
        >
          -
        </div>
        {emptyOddStyle ? <div className="emptyRadioBtnContainer">-</div> : null}
      </span>
    );
  }
);
